// biome-ignore lint/correctness/noUnusedImports: required
import React from 'react'
import { view } from 'react-easy-state'
import useModals from '../hooks/modals'
import globalState from '../state'
import Modal from './Modal'

const Modals = () => {
  const { removeModal } = useModals()

  return (
    <div id="modals">
      {globalState.modals.map((modal) => (
        <Modal key={modal.key} removeModal={removeModal} {...modal} />
      ))}
    </div>
  )
}

export default view(Modals)
